<svg
  xmlns='http://www.w3.org/2000/svg'
  width='32'
  height='32'
  viewBox='0 0 32 32'
  fill='none'></svg>;

const NonVegIcon = () => {
  return (
    <>
      <rect x='0.5' y='0.5' width='31' height='31' stroke='#D12525' />
      <circle cx='15.9997' cy='15.9997' r='9.41176' fill='#D12525' />
    </>
  );
};

export default NonVegIcon;
